import { ApplicationStatusUI } from '~entities/application';
import { PosInfo } from '~entities/pos';

import { DateTime } from '~shared/ui/date-time';
import { MoneyPh } from '~shared/ui/money-ph';

import { createColumnHelper } from '@tanstack/react-table';

import type { ApplicationsTableData } from '../model/applications-table-data';

export enum ColumnId {
  AGREEMENT_ID = 'agreementId',
  STATUS = 'status',
  DATE = 'date',
  POS = 'pos',
  SALE_AMOUNT = 'saleAmount',
  DOWN_PAYMENT = 'downPaymentAmount',
  FINANCED_AMOUNT = 'financedAmount',
}

const columnHelper = createColumnHelper<ApplicationsTableData>();

export const columns = [
  columnHelper.accessor((row) => row.agreementId, {
    id: ColumnId.AGREEMENT_ID,
    cell: (data) => data.getValue(),
    header: () => <>Agreement&nbsp;ID</>,
  }),
  columnHelper.accessor((row) => row.applicationStatus, {
    id: ColumnId.STATUS,
    cell: (data) => <ApplicationStatusUI status={data.getValue()} />,
    header: 'Status',
  }),
  columnHelper.accessor((row) => row.applicationTimestampUTC, {
    id: ColumnId.DATE,
    cell: (data) => <DateTime dateUTC={data.getValue()} />,
    header: () => <>Date&nbsp;&&nbsp;time</>,
  }),
  columnHelper.accessor((row) => row.pos, {
    id: ColumnId.POS,
    cell: (data) => (
      <div className="w-full">
        <PosInfo {...data.getValue()} />
      </div>
    ),
    header: () => <>Store name&nbsp;&&nbsp;address</>,
  }),
  columnHelper.accessor((row) => row.saleAmount, {
    id: ColumnId.SALE_AMOUNT,
    cell: (data) => (
      <div className="flex justify-end">
        <MoneyPh value={data.getValue()} />
      </div>
    ),
    header: () => <div className="flex-1 text-right">Sale amount</div>,
  }),
  columnHelper.accessor((row) => row.downPaymentAmount, {
    id: ColumnId.DOWN_PAYMENT,
    cell: (data) => (
      <div className="flex justify-end">
        <MoneyPh value={data.getValue()} />
      </div>
    ),
    header: () => <div className="flex-1 text-right">Down payment</div>,
  }),
  columnHelper.accessor((row) => row.financedAmount, {
    id: ColumnId.FINANCED_AMOUNT,
    cell: (data) => (
      <div className="flex justify-end">
        <MoneyPh value={data.getValue()} />
      </div>
    ),
    header: () => <div className="flex-1 text-right">Financed amount</div>,
  }),
];
